import { SupportButton } from '@backstage/core-components';
import { useStyles } from './supportHeader.style';

function SupportHeader() {
  const { cx, classes } = useStyles();

  return (
    <section className={cx(classes.supportHeader)}>
      <SupportButton
        title="It enables fast discovery, clear understanding, and consistent usage of message definitions across teams."
        items={[
          {
            title: 'INFSUPP',
            icon: 'support',
            links: [
              {
                title: 'Create a ticket for Triton',
                url: 'https://zf-scalar.atlassian.net/secure/CreateIssueDetails!init.jspa?pid=13079&issuetype=10672&summary=Async%20APIs%20messages%20feedback&customfield_12107=11359',
              },
            ],
          },
          {
            title: 'SAM chatbot',
            icon: 'support',
            links: [
              {
                title: 'Ask your questions to our AI bot',
                url: 'https://sam.eu1.scalar.zf.com/',
              },
            ],
          },
          {
            title: 'Documentation',
            icon: 'support',
            links: [
              {
                title: 'Read more on Confluence',
                url: 'https://zf-scalar.atlassian.net/wiki/spaces/INFINITY/pages/5148868843/Infinity+Portal+-+APIs+Viewer',
              },
            ],
          },
        ]}
      />
    </section>
  );
}

export { SupportHeader };
